import { createSelector } from '@reduxjs/toolkit'

import { getViewedSessionId } from './ui'

const getState = state => state.sharedFiles
const getSession = id => state => getState(state).map[id || getViewedSessionId(state)]

export const getPreciseSession = id => state => getState(state).map[id]

export const getFetchingInProgress = id => state => getSession(id)(state)?.fetchingInProgress

export const getSessionSharedFilesAsArray = id => createSelector(
  getSession(id),
  session => Object.values(session?.content ?? {})
)

export const selectHasMorePages = id => state => getSession(id)(state)?.hasMoreSharedFiles ?? true
export const selectLastSharedFilesPageIndex = id => state => getSession(id)(state)?.lastSharedFilesPageIndex ?? -1

export const getSharedFilesCount = id => createSelector(
  getSession(id),
  session => Object.values(session?.content ?? {}).length
)

export const getAreSharedFilesUrlsExpired = id => createSelector(
  getSession(id),
  session => {
    const now = new Date().getTime()
    const expiryTime = session?.nextExpiryTimestamp ?? 0

    return now > expiryTime
  }
)
